import T from "@/mixins/tools";

export default {
  data() {
    return {
      model_name: "Item",
      ref_model_form: "ModelForm",
      empty_object: {},
      edited_item: null,
      is_new: true,
      debug: false,
    };
  },
  methods: {
    post_create_item(item) {
      this.show_info_message({ message: `New ${this.model_name} created.` });
      this.$emit("new_item", item);
    },
    post_update_item(original_item, updated_item) {
      this.show_info_message({ message: `Updated ${this.model_name}.` });
      this.$emit("updated_item", original_item, updated_item);
    },
    post_delete_item(item) {
      this.show_info_message({ message: `Deleted ${this.model_name}.` });
      this.$emit("deleted_item", item);
    },
    async on_persist(is_new) {
      if (is_new) {
        let new_item;
        try {
          new_item = await this.actual_create_item(this.edited_item);
        } catch (error) {
          this.show_error_message(error);
          return;
        }
        if (this.post_create_item) this.post_create_item(new_item);
      } else {
        let updated_item;
        try {
          updated_item = await this.actual_update_item(this.edited_item);
        } catch (error) {
          this.show_error_message(error);
          return;
        }
        if (this.post_update_item) {
          if (this.debug)
            console.log("edited:", this.edited_item, "updated:", updated_item);
          try {
            this.post_update_item(this.edited_item, updated_item);
          } catch (error) {
            console.log(error);
          }
        }
      }

      this.$refs[this.ref_model_form]?.close_edit();
    },
    async on_erase() {
      let deleted_item;
      try {
        deleted_item = await this.actual_delete_item(this.edited_item);
      } catch (error) {
        this.show_error_message(error);
        return;
      }
      if (this.post_delete_item) this.post_delete_item(deleted_item);
      this.$refs[this.ref_model_form]?.close_delete();
    },
    on_clean() {
      this.edited_item = T.copy(this.empty_object);
    },
    create_item() {
      this.is_new = true;
      this.edited_item = T.copy(this.empty_object);
      this.set_inital_data();
      this.$refs[this.ref_model_form]?.open_edit(this.is_new);
    },
    set_inital_data() {
      //overload me
    },
    edit_item(item) {
      this.is_new = false;
      this.edited_item = T.copy(item);
      this.set_inital_data();
      this.$refs[this.ref_model_form]?.open_edit(this.is_new);
    },
    delete_item(item) {
      this.edited_item = T.copy(item);
      this.$refs[this.ref_model_form].open_delete();
    },
    async actual_create_item(item) {
      console.log(
        "Simulate success create, Raise Exception to not close dialog.",
        item
      );
    },
    async actual_update_item(item) {
      console.log(
        "Simulate success create, Raise Exception to not close dialog.",
        item
      );
    },
    async actual_delete_item(item) {
      console.log(
        "Simulate success delete, Raise Exception to not close dialog.",
        item
      );
    },
    show_error_message(error) {
      console.log(error);
    },
    show_info_message(error) {
      console.log(error);
    },
  },
  created() {
    if (this.debug) console.log("running created");
    if (this.empty_object) this.edited_item = T.copy(this.empty_object);
  },
};
